import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { TypeDeSorts } from 'src/app/_enums/typeDeSort';
import { Sort } from 'src/app/_models/sort';
import { SortService } from 'src/app/_services/sort.service';
import { Personnage } from '../../_models/personnage';
import { CharacterSheetService } from '../../_services/character-sheet.service';

@Component({
  selector: 'app-character-sheet-sorts',
  templateUrl: './sorts.component.html',
  styleUrls: ['./sorts.component.scss']
})
export class CharacterSheetSortsComponent implements OnInit {
  @Input()  personnage!: Personnage;
  @Output() personnageChange = new EventEmitter<Personnage>();
  @Input()  typeDeSort!: number;
  coutAchatSort: number = 20;
  typeDeSortDisplay: string | undefined;
  addSortForm!: FormGroup;
  submitted: boolean = false;
  sorts!: Sort[];

  availableSorts!: Sort[];

  constructor(private formBuilder: FormBuilder, private characterSheetService: CharacterSheetService, private sortService: SortService, private route: ActivatedRoute, private router: Router) {
   }

  ngOnInit(): void {
    this.initializeSortForm();
    this.typeDeSortDisplay = new TypeDeSorts().values.get(this.typeDeSort);
    
    this.sortService.getSorts()
    .pipe(first())
    .subscribe({
      next: (sorts) => {
        this.sorts = sorts.filter(s => s.type == this.typeDeSort);
        this.availableSorts = this.getSortsDisponible();
      }
    });
  }

  initializeSortForm() {
    this.addSortForm = this.formBuilder.group({
      addedSortId: ['', Validators.required]
    })
  };
  
  public getSortsDisponible() {
    const sort1 = this.getSortsPersonnage(1).length;
    const sort2 = this.getSortsPersonnage(2).length;
    const sort3 = this.getSortsPersonnage(3).length;
    const canHaveNiveau2 = sort1 >= 2;
    const canHaveNiveau3 = sort2 >= 2;
    return this.sorts.filter((s) =>
      this.personnage.sorts.find((ps) => ps.sortId == s.id) == null
      && (
        s.niveau == 1
        || (s.niveau == 2 && canHaveNiveau2)
        || (s.niveau == 3 && canHaveNiveau3)
      ));
  }

  public getSortsPersonnage(niveau: number) {
    return this.sorts.filter((s) =>
      s.niveau == niveau 
      && this.personnage.sorts.find((ps) => ps.sortId == s.id) != null);
  }

  // convenience getter for easy access to form fields
  get f() { return this.addSortForm.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.addSortForm.invalid)
    {
    // Get all Form Controls keys and loop them
      Object.keys(this.addSortForm.controls).forEach(key => {
      // Get errors of every form control
      var control = this.addSortForm.get(key);
      if(control != null)
      {
        console.log(key);
        console.log(control.errors);
      }
    });
      return;
    }

    this.characterSheetService.addSort({
      personnageId: this.personnage.id,
      sortId: this.addSortForm.controls['addedSortId'].value
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);

        this.addSortForm.controls['addedSortId'].setValue('');
        this.submitted = false;

        this.availableSorts = this.getSortsDisponible();
      }
    });
  }

  public canRemoveSort(sort: Sort): boolean {
    if (sort.niveau == 3) return true;
    const sort2 = this.getSortsPersonnage(sort.niveau+1).length;
    if (sort2 == 0) return true;

    const sort1 = this.getSortsPersonnage(sort.niveau).length;
    return sort1 > (sort2+1);
  }

  public removeSort(sort: Sort) {
    this.characterSheetService.removeSort({
      personnageId: this.personnage.id,
      sortId: sort.id
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);
        
        this.availableSorts = this.getSortsDisponible();
      }
    });
  }



  public canAddAchatSort(): boolean {
    return this.personnage.crimsonDisponible >= this.coutAchatSort;
  }

  public canRemoveAchatSort(): boolean {
    return this.personnage.achatSortDisponible >= 2 && this.personnage.achatSortAchete >= 2;
  }

  public AddAchatSort() {
    this.characterSheetService.addAchatSort({
      personnageId: this.personnage.id,
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);
      }
    });
  }

  public RemoveAchatSort() {
    this.characterSheetService.removeAchatSort({
      personnageId: this.personnage.id,
    })
    .pipe(first())
    .subscribe({
      next: (result) => {
        this.personnage = result.result as Personnage;
        this.personnageChange.emit(this.personnage);
      }
    });
  }
}